import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type PlusIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function PlusIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: PlusIconProps) {
  return (
    <Svg
      width={21}
      height={20}
      viewBox="0 0 21 20"
      fill="none"
      className={className}
      {...props}
    >
      <Path d="M10.5 3.75v12.5-12.5z" className={pathClassName} />
      <Path
        d="M10.5 3.75v12.5M16.75 10H4.25"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default PlusIcon;
